import React from 'react';
import {Modal, Button} from 'react-bootstrap';
import {Header, Body, Footer, Title} from 'react-bootstrap/lib/Modal'
import ModalWindow from './ModalWindow';

export default class ConfirmWindow extends ModalWindow
{
	constructor(title, text, style, lang = null) {
		super(title, text, null, style);
		if (lang == null) {
			this.lang = {
				ok: 'OK',
				cancel: 'Storno'
			}
		}
		else {
			this.lang = lang;
		}
	}

	handleHide(callback) {
		this.hide();
		if (callback) {
			callback();
		}
	}

	show(dispatch, okCallback, cancelCallback) {
		if (__MOBILE__) {
			navigator.notification.confirm(
				this.text,
				(buttonIndex) => {
					if (buttonIndex == 1) {
						okCallback();
					}
					if (buttonIndex == 2) {
						cancelCallback();
					}
				},
				this.title,
				[this.lang.ok, this.lang.cancel]
			);
		}
		else {
			const modal = <Modal animation={true} show={true} onHide={() => this.handleHide(cancelCallback)} bsStyle={this.style}>
				<Header closeButton>
					<Title>{this.title}</Title>
				</Header>
				<Body>
				<div style={{padding: '20px 5px'}}>
					{this.text}
				</div>
				</Body>
				<Footer>
					<Button onClick={() => this.handleHide(cancelCallback)} bsStyle="link">{this.lang.cancel}</Button>
					<Button onClick={() => this.handleHide(okCallback)} bsStyle="primary">{this.lang.ok}</Button>
				</Footer>
			</Modal>;
			this.dispatchWindow(dispatch, modal);
		}
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-modal/src/ConfirmWindow.js